import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Tab,
} from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import dayjs from "dayjs";

import TopSection from "../TopSection";
import InputData from "./InputData";
import { fetchAllPlantData } from "../../../redux/actions/Admin/AdminScheduler";
import { SaveLtJobs } from "../../../redux/actions/Admin/SaveAndRun";
import { fetchAllScheduledJobs } from "../../../redux/actions/Admin/AdminScheduler/GetScheduledJobs";
import { fetchJobRunDetails } from "../../../redux/actions/Admin/AdminScheduler/JobRunDetails";
import Modal from "../../../components/common/modal/Modal";
import JobRunDetails from "./JobRunDetails";
import { jobCancelledApi } from "../../../redux/actions/JobCancelled";
import { getJobDetailsEndpoint, jobCancelledEndpoint } from "../../../common/endpoints";
import { getJobDetailsApi } from "../../../redux/actions/GetJobDetails";
import JobDetailModal from "./JobDetailModal";
import { useNavigate } from "react-router-dom";
import SchedulerTable from "./SchedulerTable";
import { Loader } from "../../../components/common/Loader";

const modesOfTrans = [
  { value: "Road LTL", label: "Road LTL" },
  { value: "Road FTL", label: "Road FTL" },
  { value: "Pickup", label: "Pickup" },
  { value: "Air", label: "Air" },
  { value: "Sea", label: "Sea" },
  { value: "Shipping Instruction 1", label: "Shipping Instruction 1" },
  { value: "Shipping Instruction 2", label: "Shipping Instruction 2" },
  { value: "Not Specified", label: "Not Specified" },
];

const JOBTYPES = [
  {value: "LTANALYTICS", label: "Lead Time Analytics"},
  {value: "PO_ADHERENCE", label: "PO Adherence Report"},
]

const RunAnalyticsScheduler = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const defaultValue = "0 21 * * 1";
  const [scheduleValue, setScheduleValue] = useState(defaultValue);
  const [scheduleType, setScheduleType] = useState("Single-Run");
  const [tabValue, setTabValue] = useState("Scheduler");
  const [selectedModesOfTransport, setSelectedModesOfTransport] = useState([]);
  const [scheduledTime, setScheduledTime] = useState("");
  const [scheduledStartDate, setScheduledStartDate] = useState("");
  const [rows, setRows] = useState([
    { range: "Range 1", excludeFromDate: null, excludeToDate: null },
  ]);
  const [formData, setFormData] = useState({
    plant: [],
    fromDate: null,
    toDate: null,
    excludeRange: false,
    prodCriticalItem: "",
    materialTypeDesc: "",
  });
  const [showModal, setShowModal] = useState(false);
  const [isModalBtnDisabled, setIsModalBtnDisabled] = useState(true);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [excludeModalBtnDisabled, setExcludeModalBtnDisabled] = useState(true);
  const [allFetchedScheduledJobs, setAllFetchedScheduledJobs] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const completePlantData = useSelector((state) => state?.adminScheduler);
  const [singleDropdownData, setSingleDropdownData] = useState({
    plant: [],
    purchasingGroup: [],
    mrpController: [],
    scode: [],
    incotermLocation: [],
    supplierId: [],
    supplierName: [],
    materialGroup: [],
    materialType: [],
    materialId: [],
  });
  const [newJobType, setNewJobType] = useState("");
  const [dropdownData, setDropdownData] = useState();
  const [plantData, setPlantData] = useState([]);
  const [purchasingGroupData, setPurchasingGroupData] = useState([]);
  const [mrpControllerData, setMRPControllerData] = useState([]);
  const [sCodeData, setSCodeData] = useState([]);
  const [incotermsLocData, setIncotermsLocData] = useState([]);
  const [supplierCodeData, setSupplierCodeData] = useState([]);
  const [supplierNameData, setSupplierNameData] = useState([]);
  const [materialGroupData, setMaterialGroupData] = useState([]);
  const [materialTypeData, setMaterialTypeData] = useState([]);
  const [materialData, setMaterialData] = useState([]);
  const [setGetJobDetailsData] = useState([]);
  const [openjobDetailModal, setOpneJobDetailModal] = useState(false);
  const [getSeqId, setGetSeqId] = useState();
  const completeFetchedScheduledJobsData = useSelector(
    (state) => state?.getAllScheduledJobs
  );

  const userEmail = localStorage.getItem("data");
  const userRole = localStorage.getItem("LTRole");

  const handleRadioChange = (event) => {
    if (event.target.value === "Single-Run") {
      setScheduledTime("");
      setScheduledStartDate("");
    }
    setScheduleType(event.target.value);
  };

  const validateForm = useCallback(() => {
    const { fromDate, toDate, prodCriticalItem } = formData;
    if (scheduleType === "One-Time-Schedule") {
      if (
        !fromDate ||
        !toDate ||
        !prodCriticalItem ||
        !scheduledTime ||
        !scheduledStartDate ||
        !selectedModesOfTransport?.length ||
        !singleDropdownData?.materialId?.length
      ) {
        setBtnDisabled(true);
      } else {
        setBtnDisabled(false);
      }
    } else if (scheduleType === "Single-Run") {
      if (
        !fromDate ||
        !toDate ||
        !prodCriticalItem ||
        !selectedModesOfTransport?.length ||
        !singleDropdownData?.materialId?.length
      ) {
        setBtnDisabled(true);
      } else {
        setBtnDisabled(false);
      }
    } else if (scheduleType === "Recurring") {
      if (
        !fromDate ||
        !toDate ||
        !prodCriticalItem ||
        !scheduledStartDate ||
        !selectedModesOfTransport?.length ||
        !singleDropdownData?.materialId?.length
      ) {
        setBtnDisabled(true);
      } else {
        setBtnDisabled(false);
      }
    }
  }, [formData, scheduledTime, scheduledStartDate, scheduleType, selectedModesOfTransport, singleDropdownData?.materialId?.length]);

  useEffect(() => {
    validateForm();
  }, [formData, scheduledTime, scheduledStartDate, scheduleType, validateForm]);

  const handleChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]:
        event.target.type === "checkbox"
          ? event.target.checked
          : event.target.value,
    });
  };

  const handleDateChange = (date, name) => {
    setFormData({
      ...formData,
      [name]: date,
    });
  };

  const handleClose = () => {
    setShowModal(false);
    setFormData({ ...formData, excludeRange: false });
    setExcludeModalBtnDisabled(true);
    setBtnDisabled(true);
    setRows(
      rows.map((row) => ({
        ...row,
        excludeFromDate: null,
        excludeToDate: null,
      }))
    );
  };

  const clearAllExcludeModal = () => {
    setRows(
      rows.map((row) => ({
        ...row,
        excludeFromDate: null,
        excludeToDate: null,
      }))
    );
    setIsModalBtnDisabled(true);
    setExcludeModalBtnDisabled(true);
  };

  const submitExcludeModalHandler = () => {
    setFormData({ ...formData, excludeRange: true });
    setShowModal(false);
    setBtnDisabled(true);
  };

  const handleAddRows = () => {
    setRows([
      ...rows,
      {
        range: `Range ${rows.length + 1}`,
        excludeFromDate: null,
        excludeToDate: null,
      },
    ]);
  };

  const delRowHandler = (index) => {
    const newArray = rows.filter((rows, i) => i !== index && rows);
    setRows(newArray);
  };

  const handleExcludeDateChange = (date, name, index) => {
    date && setIsModalBtnDisabled(false);
    setRows(
      rows.map((row, i) => (i === index ? { ...row, [name]: date } : row))
    );
    setExcludeModalBtnDisabled(false);
  };
  const fetchAllPlantDataFromApi = async () => {
    try {
      const response = await dispatch(
        fetchAllPlantData({
          dynamicEndpoint: `api/admin/ltDropDownData`,
          params: {
            plant: localStorage.getItem("selectedLTPlantCode")
          },
        })
      );
      if (response.meta.requestStatus === "fulfilled") {
        setDropdownData(response.payload);
      } else {
        console.error("Failed to fetch data:", response.error);
      }
    } catch (error) {
      console.error("API error:", error);
    }
  };
  
  const clearAllInputSelection = () => {
    setBtnDisabled(true);
    setScheduledTime("");
    setScheduledStartDate("");
    setPlantData([]);
    setPurchasingGroupData([]);
    setMRPControllerData([]);
    setSCodeData([]);
    setIncotermsLocData([]);
    setSupplierCodeData([]);
    setSupplierNameData([]);
    setMaterialGroupData([]);
    setMaterialTypeData([]);
    setMaterialData([]);
    setSelectedModesOfTransport([]);
    setFormData({
      plant: [],
      fromDate: null,
      toDate: null,
      excludeRange: false,
      prodCriticalItem: "",
      materialTypeDesc: "",
    });
    setSingleDropdownData({
      plant: [],
      purchasingGroup: [],
      mrpController: [],
      scode: [],
      incotermLocation: [],
      supplierId: [],
      supplierName: [],
      materialGroup: [],
      materialType: [],
      materialId: [],
    })
    fetchAllPlantDataFromApi();
  };

  useEffect(() => {
    if (formData?.excludeRange) {
      setShowModal(true);
    } else if (formData?.excludeRange === false) {
      setRows((prevRows) =>
        prevRows.map((row) => ({
          ...row,
          excludeFromDate: null,
          excludeToDate: null,
        }))
      );
      setExcludeModalBtnDisabled(true);
    }
  }, [formData.excludeRange]);

  const fetchDataFromScheduledJobs = async () => {
    try {
      const response = await dispatch(fetchAllScheduledJobs({
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        },
      }));
      if (response.meta.requestStatus === "fulfilled") {
        setAllFetchedScheduledJobs(response.payload);
      } else {
        console.error("Failed to fetch data:", response.error);
      }
    } catch (error) {
      console.error("API error:", error);
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    if (newValue === "Scheduled") {
      fetchDataFromScheduledJobs();
    }
  };

  const handleEditRange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]:
        event.target.type === "checkbox"
          ? event.target.checked
          : event.target.value,
    });
    setShowModal(true);
  };

  useEffect(() => {
    fetchAllPlantDataFromApi();
  }, [dispatch]);

  useEffect(() => {
    userRole === "Viewer" && 
    setTabValue("Scheduled") 
    fetchDataFromScheduledJobs()
  }, [userRole]);

  const handleJobTypeChange = (event) => {
    setNewJobType(event.target.value);
  }

  const handleSelectedItemsChange = (name, newSelectedItems) => {
    setSingleDropdownData((prevData) => ({
      ...prevData,
      [name]: newSelectedItems,
    }));
    if (name === "plant") {
      setPlantData([])
      setPurchasingGroupData([]);
      setMRPControllerData([]);
      setSCodeData([]);
      setIncotermsLocData([]);
      setSupplierCodeData([]);
      setSupplierNameData([]);
      setMaterialGroupData([]);
      setMaterialTypeData([]);
      setMaterialData([]);
      setSingleDropdownData((prevData) => ({
        ...prevData,
        purchasingGroup: [],
        mrpController: [],
        scode: [],
        incotermLocation: [],
        supplierId: [],
        supplierName: [],
        materialGroup: [],
        materialType: [],
        materialId: [],
      }));
      // setPlantData(newSelectedItems);
      // setPurchasingGroupData(dropdownData?.filter(item => newSelectedItems.includes(item.plant )))
      const filterValues = newSelectedItems?.map((group) => group.value);
      setPlantData(filterValues)
      const filteredPlant = dropdownData?.filter((item) =>
        filterValues?.includes(item.plant)
      );

      const uniquePurchasingGroup = filteredPlant?.filter((item) => item.purchasingGroup);
      setPurchasingGroupData(uniquePurchasingGroup);
    }
    if (name === "purchasingGroup") {
      setMRPControllerData([]);
      setSCodeData([]);
      setIncotermsLocData([]);
      setSupplierCodeData([]);
      setSupplierNameData([]);
      setMaterialGroupData([]);
      setMaterialTypeData([]);
      setMaterialData([]);
      setSingleDropdownData((prevData) => ({
        ...prevData,
        mrpController: [],
        scode: [],
        incotermLocation: [],
        supplierId: [],
        supplierName: [],
        materialGroup: [],
        materialType: [],
        materialId: [],
      }));

      const filterValues = newSelectedItems?.map((group) => group.value);
      const filteredPurchasingGroup = singleDropdownData?.plant?.map((group) => group.value);
      const filteredMrpController = dropdownData?.filter(
        (item) =>
          filterValues?.includes(item.purchasingGroup) &&
          filteredPurchasingGroup?.includes(item.plant)
      );

      const uniqueMrpController = filteredMrpController?.filter((item) => item?.mrpController);
      setMRPControllerData(uniqueMrpController);
    }
    if (name === "mrpController") {
      setSCodeData([]);
      setIncotermsLocData([]);
      setSupplierCodeData([]);
      setSupplierNameData([]);
      setMaterialGroupData([]);
      setMaterialTypeData([]);
      setMaterialData([]);
      setSingleDropdownData((prevData) => ({
        ...prevData,
        scode: [],
        incotermLocation: [],
        supplierId: [],
        supplierName: [],
        materialGroup: [],
        materialType: [],
        materialId: [],
      }));
      const filterValues = newSelectedItems?.map((group) => group.value);

      const filteredPurchasingGroup = singleDropdownData?.purchasingGroup?.map((group) => group.value);
      const filteredPlants = singleDropdownData?.plant?.map((group) => group.value);
      const filteredMrpController = dropdownData?.filter(
        (item) =>
          filterValues?.includes(item.mrpController) &&
          filteredPlants?.includes(item.plant) &&
          filteredPurchasingGroup?.includes(item.purchasingGroup)
      );
      const uniqueSCode = filteredMrpController?.filter((item) => item.scode);

      setSCodeData(uniqueSCode);
    }
    if (name === "scode") {
      setIncotermsLocData([]);
      setSupplierCodeData([]);
      setSupplierNameData([]);
      setMaterialGroupData([]);
      setMaterialTypeData([]);
      setMaterialData([]);
      setSingleDropdownData((prevData) => ({
        ...prevData,
        incotermLocation: [],
        supplierId: [],
        supplierName: [],
        materialGroup: [],
        materialType: [],
        materialId: [],
      }));

      const filterValues = newSelectedItems?.map((group) => group.value);
      const filteredPurchasingGroup = singleDropdownData?.purchasingGroup?.map((group) => group.value);
      const filteredMrpController = singleDropdownData?.mrpController?.map((group) => group.value);
      const filteredPlants = singleDropdownData?.plant?.map((group) => group.value);
      const filteredSCode = dropdownData?.filter(
        (item) =>
          filterValues?.includes(item.scode) &&
          filteredPlants?.includes(item.plant) &&
          filteredPurchasingGroup?.includes(item.purchasingGroup) &&
          filteredMrpController?.includes(item.mrpController)
      );
      const uniqueIncotermLoc = filteredSCode?.filter((item) => item.incotermLocation);
      setIncotermsLocData(uniqueIncotermLoc)
    }
    if (name === "incotermLocation") {
      setSupplierCodeData([]);
      setSupplierNameData([]);
      setMaterialGroupData([]);
      setMaterialTypeData([]);
      setMaterialData([]);
      setSingleDropdownData((prevData) => ({
        ...prevData,
        supplierId: [],
        supplierName: [],
        materialGroup: [],
        materialType: [],
        materialId: [],
      }));

      const filterValues = newSelectedItems?.map((group) => group.value);
      const filteredPurchasingGroup = singleDropdownData?.purchasingGroup?.map((group) => group.value);
      const filteredMrpController = singleDropdownData?.mrpController?.map((group) => group.value);
      const filteredSCode = singleDropdownData?.scode?.map((group) => group.value);
      const filteredPlants = singleDropdownData?.plant?.map((group) => group.value);

      const filteredIncotermLoc = dropdownData?.filter((item) =>
        filterValues?.includes(item.incotermLocation) &&
        filteredPlants?.includes(item.plant) &&
        filteredPurchasingGroup?.includes(item.purchasingGroup) &&
        filteredMrpController?.includes(item.mrpController) &&
        filteredSCode?.includes(item.scode)
      );
      const uniqueSupplierId = filteredIncotermLoc?.filter((item) => item.supplierId);
      setSupplierCodeData(uniqueSupplierId)
    }
    if (name === "supplierId") {
      setSupplierNameData([]);
      setMaterialGroupData([]);
      setMaterialTypeData([]);
      setMaterialData([]);
      setSingleDropdownData((prevData) => ({
        ...prevData,
        supplierName: [],
        materialGroup: [],
        materialType: [],
        materialId: [],
      }));

      const filterValues = newSelectedItems?.map((group) => group.value);
      const filteredPurchasingGroup = singleDropdownData?.purchasingGroup?.map((group) => group.value);
      const filteredMrpController = singleDropdownData?.mrpController?.map((group) => group.value);
      const filteredSCode = singleDropdownData?.scode?.map((group) => group.value);
      const filteredIncotermLoc = singleDropdownData?.incotermLocation?.map((group) => group.value);
      const filteredPlants = singleDropdownData?.plant?.map((group) => group.value);

      const filteredSupplierId = dropdownData?.filter((item) =>
        filterValues?.includes(item.supplierId) &&
        filteredPlants?.includes(item.plant) &&
        filteredPurchasingGroup?.includes(item.purchasingGroup) &&
        filteredMrpController?.includes(item.mrpController) &&
        filteredSCode?.includes(item.scode) &&
        filteredIncotermLoc?.includes(item.incotermLocation)
      );
      const uniqueSupplierName = filteredSupplierId?.filter((item) => item.supplierName);
      setSupplierNameData(uniqueSupplierName)
    }
    if (name === "supplierName") {
      setMaterialGroupData([]);
      setMaterialTypeData([]);
      setMaterialData([]);
      setSingleDropdownData((prevData) => ({
        ...prevData,
        materialGroup: [],
        materialType: [],
        materialId: [],
      }));

      const filterValues = newSelectedItems?.map((group) => group.value);
      const filteredPurchasingGroup = singleDropdownData?.purchasingGroup?.map((group) => group.value);
      const filteredMrpController = singleDropdownData?.mrpController?.map((group) => group.value);
      const filteredSCode = singleDropdownData?.scode?.map((group) => group.value);
      const filteredIncotermLoc = singleDropdownData?.incotermLocation?.map((group) => group.value);
      const filteredSupplierId = singleDropdownData?.supplierId?.map((group) => group.value);
      const filteredPlants = singleDropdownData?.plant?.map((group) => group.value);

      const filteredSupplierName = dropdownData?.filter((item) =>
        filterValues?.includes(item.supplierName) &&
        filteredPlants?.includes(item.plant) &&
        filteredPurchasingGroup?.includes(item.purchasingGroup) &&
        filteredMrpController?.includes(item.mrpController) &&
        filteredSCode?.includes(item.scode) &&
        filteredIncotermLoc?.includes(item.incotermLocation) &&
        filteredSupplierId?.includes(item.supplierId)
      );

      const uniqueMaterialGrp = filteredSupplierName?.filter((item) => item.materialGroup);
      setMaterialGroupData(uniqueMaterialGrp)
    }
    if (name === "materialGroup") {
      setMaterialTypeData([]);
      setMaterialData([]);
      setSingleDropdownData((prevData) => ({
        ...prevData,
        materialType: [],
        materialId: [],
      }));

      const filterValues = newSelectedItems?.map((group) => group.value);
      const filteredPurchasingGroup = singleDropdownData?.purchasingGroup?.map((group) => group.value);
      const filteredMrpController = singleDropdownData?.mrpController?.map((group) => group.value);
      const filteredSCode = singleDropdownData?.scode?.map((group) => group.value);
      const filteredIncotermLoc = singleDropdownData?.incotermLocation?.map((group) => group.value);
      const filteredSupplierId = singleDropdownData?.supplierId?.map((group) => group.value);
      const filteredSupplierName = singleDropdownData?.supplierName?.map((group) => group.value);
      const filteredPlants = singleDropdownData?.plant?.map((group) => group.value);

      const filteredMaterialGroup = dropdownData?.filter((item) =>
        filterValues?.includes(item.materialGroup) &&
        filteredPlants?.includes(item.plant) &&
        filteredPurchasingGroup?.includes(item.purchasingGroup) &&
        filteredMrpController?.includes(item.mrpController) &&
        filteredSCode?.includes(item.scode) &&
        filteredIncotermLoc?.includes(item.incotermLocation) &&
        filteredSupplierId?.includes(item.supplierId) &&
        filteredSupplierName?.includes(item.supplierName)
      );

      const uniqueMaterialType = filteredMaterialGroup?.filter((item) => item.materialType);
      setMaterialTypeData(uniqueMaterialType)
    }
    if (name === "materialType") {
      setMaterialData([]);
      setSingleDropdownData((prevData) => ({
        ...prevData,
        materialId: [],
      }));

      const filterValues = newSelectedItems?.map((group) => group.value);
      const filteredPurchasingGroup = singleDropdownData?.purchasingGroup?.map((group) => group.value);
      const filteredMrpController = singleDropdownData?.mrpController?.map((group) => group.value);
      const filteredSCode = singleDropdownData?.scode?.map((group) => group.value);
      const filteredIncotermLoc = singleDropdownData?.incotermLocation?.map((group) => group.value);
      const filteredSupplierId = singleDropdownData?.supplierId?.map((group) => group.value);
      const filteredSupplierName = singleDropdownData?.supplierName?.map((group) => group.value);
      const filteredMaterialGroup = singleDropdownData?.materialGroup?.map((group) => group.value);
      const filteredPlants = singleDropdownData?.plant?.map((group) => group.value);

      const filteredMaterialType = dropdownData?.filter((item) =>
        filterValues?.includes(item.materialType) &&
        filteredPlants?.includes(item.plant) &&
        filteredPurchasingGroup?.includes(item.purchasingGroup) &&
        filteredMrpController?.includes(item.mrpController) &&
        filteredSCode?.includes(item.scode) &&
        filteredIncotermLoc?.includes(item.incotermLocation) &&
        filteredSupplierId?.includes(item.supplierId) &&
        filteredSupplierName?.includes(item.supplierName) &&
        filteredMaterialGroup?.includes(item.materialGroup)
      );

      const uniqueMaterial = filteredMaterialType?.filter((item) => item.materialId);
      setMaterialData(uniqueMaterial);

    }
  }

  const handleModeOfTransportChange = (event, newValue) => {
    if (newValue?.some((option) => option?.value === "all")) {
      if (selectedModesOfTransport?.length === modesOfTrans?.length) {
        setSelectedModesOfTransport([]);
      } else {
        setSelectedModesOfTransport(modesOfTrans);
      }
    } else {
      setSelectedModesOfTransport(newValue);
    }
  };

  const handleDeleteAll = (setSelectedFunction) => {
    setSelectedFunction([]);
  };

  const addSelectAllOption = (options) => {
    return ["Select All", ...options];
  };

  const SelectAllModesOfTransport = (options) => {
    return [{ value: "all", label: "Select All" }, ...options];
  };

  const handleSaveRun = async (e) => {
    e.preventDefault();
    setLoading(true);
    const modeOfTransportData = selectedModesOfTransport?.map(
      (mode) => mode?.value
    );
    const formattedFromDate = formData.fromDate
      ? dayjs(formData.fromDate).format("YYYY-MM-DD")
      : null;
    const formattedToDate = formData.toDate
      ? dayjs(formData.toDate).format("YYYY-MM-DD")
      : null;

    let formattedExcludeRange = [];
    if (
      rows.length &&
      rows[0].excludeFromDate === null &&
      rows[0].excludeToDate === null
    ) {
      formattedExcludeRange = [];
    } else {
      formattedExcludeRange = rows.map(
        ({ range, excludeFromDate, excludeToDate }) => ({
          excludeFrom: excludeFromDate
            ? dayjs(excludeFromDate).format("YYYY-MM-DD")
            : null,
          excludeTo: excludeToDate
            ? dayjs(excludeToDate).format("YYYY-MM-DD")
            : null,
        })
      );
    }
    const selectedSupplierId = singleDropdownData?.supplierId?.map((item) => item?.value);
    const selectedMaterial = singleDropdownData?.materialId?.map((item) => item?.value);
    const selectedIncotermsLocation = singleDropdownData?.incotermLocation?.map((item) => item?.value);
    const selectedPlants = singleDropdownData?.plant?.map((item) => item?.value);
    try {
      const response = await dispatch(
        SaveLtJobs({
          data: {
            userEmail: userEmail,
            jobType: newJobType,
            plantName: localStorage.getItem("selectedLTPlantCode"),
            plants: selectedPlants,
            supplierIds: selectedSupplierId,
            materialIds: selectedMaterial.map(item => item?.split("|")[0]),
            incotermsLocations: selectedIncotermsLocation,
            modeOfTransports: modeOfTransportData,
            periodFrom: formattedFromDate,
            periodTo: formattedToDate,
            excludeRanges: formattedExcludeRange,
            scheduleLabel: formData?.prodCriticalItem,
            scheduleDescription: formData?.materialTypeDesc,
            scheduleType: scheduleType,
            cronExp: scheduleValue,
            scheduleStartDate: scheduledStartDate,
            scheduleStartTime: scheduledTime,
          },
          params: {
            plant: localStorage.getItem("selectedLTPlantCode")
          },
        })
      );
      if (response.meta.requestStatus === "fulfilled") {
        setLoading(false);
        toast.success(response?.payload, {
          autoClose: 2000,
        });
        setSelectedModesOfTransport([]);
        setNewJobType("");
        setScheduledTime("");
        setScheduledStartDate("");
        setScheduleType("Single-Run");
        setBtnDisabled(true);
        setFormData((prevFormData) => ({
          ...prevFormData,
          fromDate: null,
          toDate: null,
          excludeRange: false,
          prodCriticalItem: "",
          materialTypeDesc: "",
        }));
        setPlantData([]);
        setSingleDropdownData((prevData) => ({
          ...prevData,
          plant: [],
          purchasingGroup: [],
          mrpController: [],
          scode: [],
          incotermLocation: [],
          supplierId: [],
          supplierName: [],
          materialGroup: [],
          materialType: [],
          materialId: [],
        }));
        fetchAllPlantDataFromApi();
      } else {
        setLoading(false);
        toast.error(response?.error, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      toast.success(error, {
        autoClose: 2000,
      });
    }
  };

  const handleJobRunDetails = useCallback(
    (id) => {
      const fetchDataFromApi = async () => {
        try {
          const response = await dispatch(
            fetchJobRunDetails({
              dynamicEndpoint: `api/admin/jobRunDetails/${id}`,
              params: {
                plant: localStorage.getItem("selectedLTPlantCode")
              },
            })
          );
          if (response.meta.requestStatus === "fulfilled") {
          } else {
            console.error("Failed to fetch data:", response.error);
          }
        } catch (error) {
          console.error("API error:", error);
        }
      };
      fetchDataFromApi();
      setOpenModal(true);
    },
    [dispatch]
  );

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleCancelledJob = (id) => {
    setLoading(true);
    const cancelLtJob = async () => {
      try {
        const response = await dispatch(
          jobCancelledApi({
            dynamicEndpoint: `${jobCancelledEndpoint}/${id}`,
            params: {
              plant: localStorage.getItem("selectedLTPlantCode")
            },
          })
        );
        if (response.meta.requestStatus === "fulfilled") {
          toast.success(response.payload, {
            autoClose: 2000,
          });
          fetchDataFromScheduledJobs();
          setLoading(false);
        } else {
          console.error("Failed to fetch data:", response.error);
        }
      } catch (error) {
        console.error("API error:", error);
      }
    };
    cancelLtJob();
  };

  const handleGetJobDetails = async (id) => {
    setOpneJobDetailModal(true);
    setGetSeqId(id);
    try {
      const response = await dispatch(
        getJobDetailsApi({
          dynamicEndpoint: `${getJobDetailsEndpoint}/${id}`,
          params: {
            plant: localStorage.getItem("selectedLTPlantCode")
          },
        })
      );
      if (response.meta.requestStatus === "fulfilled") {
        setGetJobDetailsData(response?.payload);
      } else {
        console.error("Failed to fetch data:", response.error);
      }
    } catch (error) {
      console.error("API error:", error);
    }
  }

  const viewJobHandler = () => {
    navigate('/admin-analytics-results')
  }

  return (
    <>
      <TopSection
        tabTitle="Schedule Configurator"
        labelList={[
          { title: "Home", path: "/landing-page" },
          { title: "Schedule Configurator" },
        ]}
      />
      <Box
        sx={{
          width: "100%",
          typography: "body1",
          "& .MuiTabs-root": { minHeight: "40px !important" },
        }}
      >
        {loading ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "300px",
            }}
          >
            <CircularProgress color="inherit" />
          </Box>
        ) : (
          <TabContext value={tabValue}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleTabChange}
                aria-label="lab API tabs example"
                sx={{
                  "& .Mui-selected": {
                    backgroundColor: "#aaaaaa",
                    color: "#000 !important",
                    borderRadius: "10px",
                  },
                  "& .MuiTabs-indicator": {
                    display: "none",
                  },
                }}
              > 
                <Tab
                  label="Scheduler"
                  value="Scheduler"
                  disabled={userRole === "Viewer"}
                  sx={{
                    width: "50%",
                    fontSize: "13px",
                    minHeight: "40px !important",
                    maxWidth: "700px",
                  }}
                />
                <Tab
                  label="Scheduled Jobs"
                  value="Scheduled"
                  sx={{
                    width: "50%",
                    fontSize: "13px",
                    minHeight: "40px !important",
                    maxWidth: "700px",
                  }}
                />
              </TabList>
            </Box>
            <TabPanel value="Scheduler">
              {completePlantData?.loading ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "300px",
                  }}
                >
                  <CircularProgress color="inherit" />
                </Box>
              ) : (
                <InputData
                  rows={rows}
                  formData={formData}
                  showModal={showModal}
                  handleDateChange={handleDateChange}
                  handleChange={handleChange}
                  handleAddRows={handleAddRows}
                  delRowHandler={delRowHandler}
                  handleExcludeDateChange={handleExcludeDateChange}
                  clearAllExcludeModal={clearAllExcludeModal}
                  submitExcludeModalHandler={submitExcludeModalHandler}
                  handleClose={handleClose}
                  clearAllInputSelection={clearAllInputSelection}
                  handleSaveRun={handleSaveRun}
                  isModalBtnDisabled={isModalBtnDisabled}
                  btnDisabled={btnDisabled}
                  handleRadioChange={handleRadioChange}
                  scheduleType={scheduleType}
                  scheduleValue={scheduleValue}
                  setScheduleValue={setScheduleValue}
                  handleEditRange={handleEditRange}
                  excludeModalBtnDisabled={excludeModalBtnDisabled}
                  allPlantData={completePlantData?.data}
                  handleDeleteAll={handleDeleteAll}
                  addSelectAllOption={addSelectAllOption}
                  modesOfTrans={modesOfTrans}
                  selectedModesOfTransport={selectedModesOfTransport}
                  setSelectedModesOfTransport={setSelectedModesOfTransport}
                  handleModeOfTransportChange={handleModeOfTransportChange}
                  SelectAllModesOfTransport={SelectAllModesOfTransport}
                  scheduledTime={scheduledTime}
                  setScheduledTime={setScheduledTime}
                  scheduledStartDate={scheduledStartDate}
                  setScheduledStartDate={setScheduledStartDate}
                  setBtnDisabled={setBtnDisabled}
                  fromDate={formData?.fromDate}
                  toDate={formData?.toDate}
                  singleDropdownData={singleDropdownData}
                  plantData={plantData}
                  purchasingGroupData={purchasingGroupData}
                  mrpControllerData={mrpControllerData}
                  sCodeData={sCodeData}
                  incotermsLocData={incotermsLocData}
                  supplierCodeData={supplierCodeData}
                  supplierNameData={supplierNameData}
                  materialGroupData={materialGroupData}
                  materialTypeData={materialTypeData}
                  materialData={materialData}
                  handleSelectedItemsChange={handleSelectedItemsChange}
                  dropdownData={dropdownData}
                  JOBTYPES={JOBTYPES}
                  newJobType={newJobType}
                  handleJobTypeChange={handleJobTypeChange}
                />
              )}
            </TabPanel>
            <TabPanel value="Scheduled">
              {completeFetchedScheduledJobsData.loading ? (
                <Loader />
              ) : (
                <SchedulerTable
                  allFetchedScheduledJobs={allFetchedScheduledJobs}
                  setAllFetchedScheduledJobs={setAllFetchedScheduledJobs}
                  fetchDataFromScheduledJobs={fetchDataFromScheduledJobs}
                  handleCancelledJob={handleCancelledJob}
                  handleGetJobDetails={handleGetJobDetails}
                  handleJobRunDetails={handleJobRunDetails}
                  viewJobHandler={viewJobHandler}
                  userRole={userRole}
                />
              )}
              <Modal
                handleClose={handleCloseModal}
                open={openModal}
                title="Job Run Status"
                content={<JobRunDetails />}
                maxWidth="ls"
              />
            </TabPanel>
            {openjobDetailModal && (
              <JobDetailModal
                open={openjobDetailModal}
                handleClose={() => setOpneJobDetailModal(false)}
                setOpneJobDetailModal={setOpneJobDetailModal}
                title="Edit Job"
                fullWidth={true}
                seqId={getSeqId}
                fetchDataFromScheduledJobs={fetchDataFromScheduledJobs}
              />
            )}
          </TabContext>
        )}
      </Box>
    </>
  );
};

export default RunAnalyticsScheduler;